module.exports = __webpack_public_path__ + "static/media/copyright-eu.57c02b7a.webp";